import { de } from "date-fns/locale";
import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// Organization
export const GetOrganization = async () => {
  return await axios.get(`${api.ADMIN.ORGANIZATION}`, { mode: "cors" });
};

// Add or Edit Employee
export const AddOrEditEmployee = async (formData) => {
  return axios.post(`${api.ADMIN.ADD_EDIT_EMPLOYEE}`, formData);
};

//Change Employee Status
export const ChangeEmployeeStatus = async (formData) => {
  return axios.post(`${api.ADMIN.CHANGE_EMPLOYEE_STATUS}`, formData);
};

export const ChangeEmployeDepartment = async (formData) => {
  return axios.post(`${api.ADMIN.CHANGE_EMP_DEPARTMENT}`, formData);
};
// Add Employee From Excel
export const AddBulkEmployee = async (formData) => {
  return axios.post(`${api.ADMIN.ADD_BULK_EMPLOYEE}`, formData, { responseType: 'blob' });
};

export const SampleFileDownload = async () => {
  return axios.get(`${api.ADMIN.SAMPLE_FILE_DOWNLOAD}`);
};

//Job Description
export const GetJobDescription = async () => {
  return await axios.get(`${api.ADMIN.JOB_DESCRIPTION}`);
};

//New Job Description
export const GetJobDescriptionnew = async () => {
  return await axios.get(`${api.ADMIN.GET_ROLES}`);
};

// Reporting Under
export const GetReportingUser = async () => {
  return await axios.get(`${api.ADMIN.REPORTING_USER}`);
};

export const GetAllEmployeeTypes = async () => {
  return await axios.get(`${api.ADMIN.GET_ALL_EMPLOYEE_TYPE}`);
};

//Manager
export const GetManager = async () => {
  return await axios.get(`${api.ADMIN.MANAGER_USER}`);
};

//Training
export const GetTrainingList = async () => {
  return await axios.get(`${api.ADMIN.TRAININGLIST}`);
};
//Department
export const GetDepartment = async (user) => {
  return axios.get(`${api.ADMIN.DEPARTMENT}?DepartmentSupervisorName=${user}`);
};

export const GetAllDepartments = async () => {
  return axios.get(`${api.ADMIN.MASTER_DEPARTMENT}`);
};
export const GetDesignation = async (selectedDept) => {
  return axios.get(`${api.ADMIN.MASTER_DESIGNATION}?DepartmentId=${selectedDept}`);
};
export const GetEmployeeById = async (employeeId) => {
  return axios.get(`${api.ADMIN.GET_EMPLOYEE_BYID}?EmployeeId=${employeeId}`);
};

// GetAllEmployeeDropDown
export const GetEmployeeDropDown = async () => {
  return axios.get(`${api.ADMIN.GET_ALL_EMPLOYEE_DROPDOWN}`);
};

// GetAllEmployeeDropDown
export const SendEvalutionForm = async (formData) => {
  return axios.post(`${api.HUMAN_RESOURCE.SENDEVALUTIONFORM}`, formData);
};
export const TrainingStatus = async (formData) => {
   
  return axios.post(`${api.ADMIN.SAVE_TRAINING_DETAILS}`,formData);

};
export const DownloadEmployeePdf = async (EmployeeId) => {
   
  return axios.get(`${api.ADMIN.DOWNLOAD_PDF_ADD_EMPLOYEE}?EmployeeId=${EmployeeId}`);

};

// POST API FOR ADD EMPLOYEE
// export const AddEmployee = async (data) => {
//   const formData = new FormData();
//   formData.append("Id", data.id)
//   formData.append("PersonID", data.employeeId);
//   formData.append("FirstName", data.firstName);
//   formData.append("LastName", data.lastName);
//   formData.append("Organization", data.organization);
//   formData.append("Department", data.department);
//   formData.append("EmpPosition", data.empPosition);
//   formData.append("ReportingUnder", data.reportingUnder);
//   formData.append("DOB", data.dob);
//   formData.append("Gender", data.gender);
//   formData.append("Address1", data.address1);
//   formData.append("Address2", data.address2);
//   formData.append("EmailAddress", data.emailAddress);
//   formData.append("BloodGroup", data.bloodGroup);
//   formData.append("DOJ", data.doj);
//   formData.append("AvatarImage", data.avatarImage);
//   formData.append("SignatureImage", data.signatureImage);
//   formData.append("PhoneNo", data.phoneNo);
//   formData.append("Role", data.roleId);

//   return axios.post(`${api.ADMIN.ADD_EMPLOYEE}`, formData);
// };

// Check If EmployeeID already exists
export const GetExistEmployee = async (id) => {
  return axios.get(`${api.ADMIN.CHECK_EMPLOYEE_EXIST}?EmployeeId=${id}`);
};

export const GetExistEmail = async (eid) => {
  return axios.get(`${api.ADMIN.CHECK_EMAIL_EXIST}?EmailAddress=${eid}`);
};

//GET API for employee limit
export const GetLimit = async () => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_LIMIT}`);
};
export const GetOfficeEmployee = async () => {
  return await axios.get(`${api.ADMIN.OFFICE_EMPLOYEE}`);
};

//GET API for employee limit
export const GetEmployeeDetails = async (value) => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_DETAIL}?EmployeeId=${value}`);
};

//GET api for search limit
export const GetSearch = async (value) => {
  return await axios.get(`${api.ADMIN.EMPLOYEE_LIMIT}?SearchKeyword=${value}`);
};

// Sorting data
export const GetSort = async (value, dir) => {
  return await axios.get(
    `${api.ADMIN.EMPLOYEE_LIMIT}?SortExpression=${value}%20${dir}`
  );
};

// POST API for update employee limit
export const UpdateLimit = async (data) => {
  // const data = { limitId: id, limit: limit };
  return axios.post(`${api.ADMIN.UPDATE_LIMIT}`, data);
};

// POST API for changing employee status
export const ChangeStatus = async (data) => {
  return axios.post(`${api.ADMIN.CHANGE_STATUS}`, data);
};

//Get Document Approval List
export const GetDocumentList = async (data) => {
  return await axios.post(`${api.ADMIN.DOCUMENT_APPROVAL}`, data);
};

// Update Document List
export const UpdateDocumentList = async (data) => {
  return axios.post(`${api.ADMIN.UPDATE_APPROVAL_LIST}`, data);
};

// Update Document List
export const GetUserRolesRights = async () => {
  return axios.get(`${api.ADMIN.GET_USER_ROLES_RIGHTS}`);
};

//Get Employee Position
export const GetPosition = async () => {
  return axios.get(`${api.ADMIN.GET_POSITION}`);
};


export const GetRoles = async () => {
  return axios.get(`${api.ADMIN.GET_ROLES}`);
};

export const GetRightsById = async ({ roleId = null, userId = null, departmentid = null }) => {
  let params = {};

  if (roleId) {
    params.RoleId = roleId;
  } else if (userId) {
    params.UserId = userId;
  } else if (departmentid) {
    params.departmentid = departmentid;
  }

  return axios.get(api.ADMIN.GET_RIGHTS_BY_ID, { params });
};

export const UpdateRightsById = async (data) => {
  return axios.post(`${api.ADMIN.UPDATE_RIGHTS_BY_ID}`, data);
};

export const AddDepartment = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "INSERT",
    ...data,
  });
};

export const UpdateDepartment = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteDepartment = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDepartment, {
    Action: "DELETE",
    Id: id,
  });
};

export const AddTraining = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "INSERT",
    RoleId: 1,
    ...data,
  });
};

export const UpdateTraining = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteTraining = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteTraining, {
    Action: "DELETE",
    Id: id,
  });
};

export const AddDesignation = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "INSERT",
    RoleId: 1,
    IsActive: true,
    ...data,
  });
};

export const UpdateDesignation = (data) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "UPDATE",
    ...data,
  });
};

export const DeleteDesignation = (id) => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "DELETE",
    Id: id,
  });
};

export const GetDesignationList = () => {
  return axios.post(api.ADMIN.AddOrEditOrDeleteDesignation, {
    Action: "GET",
  });
};

export const GetDesignationByDepartmentIdApi = (departmentId) => {
  return axios.get(api.ADMIN.GetDesignationByDepartmentId, {
    params: {
      DepartmentId: departmentId,
    },
  });
};